import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"float":"right"} }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Create new policy", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Name", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_CheckMark = _resolveComponent("CheckMark")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoDialog = _resolveComponent("DodoDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.mdmPolicies,
      "responsive-layout": "scroll",
      paginator: true,
      rows: 25,
      "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      "rows-per-page-options": [10,25,100],
      "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
      onSort: _ctx.sort,
      onRowClick: _ctx.rowClick
    }, {
      header: _withCtx(() => [
        _createVNode(_component_DodoButton, {
          color: "info",
          disabled: _ctx.creationLoading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Create policy ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
              placeholder: "Search"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_PrimeColumn, {
          field: "name",
          header: "Name",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeColumn, {
          field: "name",
          header: "Parent",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.getParentName(data)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeColumn, {
          field: "nApps",
          header: "Number of apps",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.policy?.applications?.length || 0), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeColumn, {
          field: "kioskMode",
          header: "Kiosk mode",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_CheckMark, {
              checked: data.policy?.kioskCustomization
            }, null, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeColumn, {
          field: "openPlayStore",
          header: "Open Play Store",
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_CheckMark, {
              checked: _ctx.hasOpenPlayStore(data.policy)
            }, null, 8, ["checked"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onSort", "onRowClick"]),
    _createVNode(_component_DodoDialog, { active: _ctx.showDialog }, {
      controls: _withCtx(() => [
        _createVNode(_component_DodoButton, {
          variant: "text",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog=false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }),
        _createVNode(_component_DodoButton, {
          variant: "solid",
          color: "info",
          onClick: _ctx.createPolicy
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Create ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_InputText, {
          modelValue: _ctx.newPolicyName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPolicyName) = $event)),
          placeholder: "Name"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
}